import { Tab } from '@hologram-dimension/tab';
import ReleaseFlag from 'api/legacy/releaseFlags/enumReleaseFlags';
import { clsx } from 'clsx/lite';
import { BorderlessPanel } from 'components';
import { useUserInfo } from 'hooks';
import sharedPageStyles from 'pages/sharedPage.module.css';
import { type FC } from 'react';
import useOrganization from 'state/contexts/Organization/useOrganization';
import useOrgUrl from 'utils/legacy/useOrgUrl';
import { UsageBySessionView, UsageBySimView, UsageOverviewView } from 'views';
import OrganizationLocationHistory from 'views/UsageReports/OrganizationLocationHistory/OrganizationLocationHistory';
import styles from './UsageReports.module.css';

const views = {
  overview: 'Overview',
  bysim: 'By SIM',
  bylocation: 'By location',
  bysession: 'By session',
};

export type UsageReportViews = keyof typeof views | null;

interface UsageReportsProps {
  className?: string;
  viewKey: UsageReportViews;
  handleTabClick: (url: string) => void;
  usageBaseUrl: string;
}

const UsageReports: FC<UsageReportsProps> = ({
  className,
  handleTabClick,
  usageBaseUrl,
  viewKey,
}) => {
  const orgId = useOrganization();
  const url = useOrgUrl({ baseUrl: usageBaseUrl, orgId });
  const { releaseFlags } = useUserInfo();
  const showLocations = !releaseFlags?.has(ReleaseFlag.HIDE_TOWER_LOCATIONS);

  return (
    <div className={clsx(sharedPageStyles.pageWrapper, styles.wrapper, className)}>
      <BorderlessPanel
        headerContents={<div className={styles.headerContents}>Data usage for all SIMs</div>}
        headerClassName={styles.header}
        contentsClassName={styles.contents}
        tabs={
          <div className={clsx(sharedPageStyles.tabWrapper, styles.tabWrapper)}>
            {Object.keys(views)
              .filter((view) => view !== 'bylocation' || showLocations)
              .map((view) => (
                <Tab
                  key={view}
                  selected={view === viewKey}
                  onClick={() => handleTabClick(`${url}/${view}`)}
                >
                  {views[view as NonNullable<UsageReportViews>]}
                </Tab>
              ))}
          </div>
        }
      >
        <div className={sharedPageStyles.viewsWrapperNoPadding}>
          {viewKey === 'overview' && <UsageOverviewView />}
          {viewKey === 'bysim' && <UsageBySimView />}
          {viewKey === 'bylocation' && <OrganizationLocationHistory />}
          {viewKey === 'bysession' && <UsageBySessionView />}
        </div>
      </BorderlessPanel>
    </div>
  );
};
export default UsageReports;
